<script setup lang="ts">
import type { ARServiceItem } from '@/models/airRoad';

import KTextField from '@/components/fields/KTextField.vue';
import { requiredValidationRule } from '@/helpers/validationRules';

const model = defineModel<ARServiceItem>({
  default: () => ({}),
});
</script>

<template>
  <fieldset
    :class="$style.newAirRoadSpecialOptionPckReqFieldset"
    data-testid="newAirRoadSpecialOptionPckReqFieldset"
  >
    <KTextField
      v-model="model.description"
      size="sm"
      label="Description"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
  </fieldset>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadSpecialOptionPckReqFieldset {
}
  .field {
    margin-top: 0.5rem;
  }
</style>
